import { withStyles } from '@material-ui/core';

import GroupEmailRecipientsItem from './GroupEmailRecipientsItem';
import styles from './GroupEmailRecipientsItem.styles';

export default withStyles(styles)(GroupEmailRecipientsItem);
